const ENTER_KEY = 13;

export const keyDownService = {
    saveNewItem(e, callback) {
        if(e.keyCode === ENTER_KEY) {
            callback();
        }
    },
};
